<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <div class="mian-content">
          <div class="side">
            <el-input
              class="input"
              placeholder="请搜索岗位"
              v-model="sideJob"
              @input="event_change"
            ></el-input>
            <el-select
              class="project_type"
              placeholder="全部岗位"
              v-model="sideIndex"
              @change="event_tabChange"
            >
              <el-option
                v-for="(item, index) in tabsArr"
                :key="index"
                :label="item.label"
                :value="item.val"
              >
              </el-option>
            </el-select>
            <div class="tipTxtTotal">
              <span class="tipTxtTotal_left">
                岗位总数<span class="tipTxtTotal_left_theme"
                  >({{ sideListTotal || 0 }})</span
                >
              </span>
              <span
                class="tipTxtTotal_right"
                @click="event_selectProject('')"
                v-if="sidetabIndex !== ''"
                >显示全部</span
              >
            </div>
            <el-scrollbar scroll-y class="scrollbarWrap">
              <div class="scrolllist">
                <div
                  :class="
                    sidetabIndex == item.id ? 'listcell active' : 'listcell'
                  "
                  v-for="item in sideList"
                  :key="item.id"
                  @click="event_selectProject(item.id)"
                >
                  <span class="listcell_text">{{ item.recruit_post }}</span>
                  <span class="listcell_num"
                    >{{ item.work_add_num }}/{{ item.worked_num }}</span
                  >
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div class="list">
            <div class="wrap-tab">
              <div class="row-tab">
                <div
                  v-for="(item, index) in tabs"
                  :key="index"
                  :class="index == tabIndex ? 'item active' : 'item'"
                  @click="event_tabClick(item)"
                >
                  <span class="label">{{ item.label }}</span>
                  <span class="val">{{ item.num }}</span>
                </div>

                <div
                  class="item select"
                  v-if="tabs[tabIndex] && tabs[tabIndex].selectShow"
                >
                  <el-select
                    v-model="tabs[tabIndex].selectVal"
                    placeholder="全部"
                    clearable
                    @change="event_status_change(tabs[tabIndex].field, $event)"
                  >
                    <el-option
                      v-for="(item_zi, index_zi) in tabs[tabIndex].select"
                      :key="index_zi"
                      :label="item_zi.label"
                      :value="item_zi.val"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div>
                <!-- <el-button
                  type="primary"
                  size="medium"
                  @click="openDialog"
                  >添加候选人</el-button
                > -->
              </div>
            </div>

            <el-row justify="space-between">
              <el-col :span="22">
                <el-form
                  size="medium"
                  :inline="true"
                  :model="searchCondition"
                  class="demo-form-inline"
                >
                  <el-form-item label="姓名" prop="realname">
                    <el-input
                      v-model="searchCondition.realname"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="时间">
                    <DatePicker @dataSearch="dataSearch" />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="searchButton"
                      >查询</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <ApeTable
              ref="apeTable"
              :data="dataList"
              :columns="columns"
              :loading="loadingStaus"
              :pagingData="pagingData"
              @switchPaging="switchPaging"
              highlight-current-row
            >
              <el-table-column label="状态" align="center" width="100px">
                <template slot-scope="scope">
                  <div class="item" v-show="tabIndex == 0">
                    <span>{{ scope.row.status_text }}</span>
                  </div>
                  <div class="item" v-show="tabIndex == 1">
                    <span>{{ scope.row.status_interview_text }}</span>
                  </div>
                  <div class="item" v-show="tabIndex == 2">
                    <span>{{ scope.row.interview_status_text }}</span>
                  </div>
                  <div class="item" v-show="tabIndex == 3">
                    <span>{{ scope.row.leave_job_status_text }}</span>
                    <!-- <span v-if="scope.row.sign_status == 0">未签约</span>
                    <span v-if="scope.row.sign_status == 1">待签约</span>
                    <span v-if="scope.row.sign_status == 2">已签约</span>
                    <span v-if="scope.row.sign_status == 3">签约失败</span> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="300px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status == '0' && tabIndex == 0"
                    size="mini"
                    type="primary"
                    @click="examineClick(scope.row)"
                    >审核</el-button
                  >
                  <div v-if="tabIndex == 1">
                    <el-button
                      size="mini"
                      type="primary"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'smsInterview' } },
                          scope.row
                        )
                      "
                      >短信面试邀约</el-button
                    ><el-button
                      size="mini"
                      type="primary"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'showfj' } },
                          scope.row
                        )
                      "
                      >查看附件</el-button
                    >
                    <el-button
                      size="mini"
                      v-if="scope.row.is_send_interview != 1"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'transferInterviewRess' } },
                          scope.row
                        )
                      "
                      type="danger"
                      >转入面试结果</el-button
                    >
                  </div>
                  <div v-if="tabIndex == 2">
                    <el-button
                      size="mini"
                      v-if="scope.row.resume_url"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'showfj' } },
                          scope.row
                        )
                      "
                      style="margin-right: 10px"
                      >查看附件</el-button
                    >

                    <el-button
                      size="mini"
                      style="margin-right: 10px"
                      @click="
                        event_buttonGroupTap(
                          {
                            item: {
                              flag: 'interview_pass',
                              type: 'confirm_second',
                              label: '审核通过',
                            },
                          },
                          scope.row
                        )
                      "
                      >通过</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="
                        event_buttonGroupTap(
                          {
                            item: {
                              flag: 'interview_nopass',
                              type: 'confirm_second',
                              label: '淘汰',
                            },
                          },
                          scope.row
                        )
                      "
                      >淘汰</el-button
                    >
                  </div>
                  <div v-show="tabIndex == 3">
                    <el-button
                      size="mini"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'showfj' } },
                          scope.row
                        )
                      "
                      style="margin-right: 10px"
                      >查看附件</el-button
                    >
                    <el-button
                      size="mini"
                      v-if="scope.row.leave_job_status == 0"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'ensureInJob' } },
                          scope.row
                        )
                      "
                      >确认入职</el-button
                    >
                    <el-button
                      size="mini"
                      v-if="scope.row.leave_job_status == 0"
                      type="danger"
                      @click="
                        event_buttonGroupTap(
                          { item: { flag: 'ensureLeaveJob' } },
                          scope.row
                        )
                      "
                      style="margin-right: 10px"
                      >未入职</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </ApeTable>
          </div>
        </div>

        <el-dialog
          v-if="examinedialogVisible"
          title=""
          :visible.sync="examinedialogVisible"
          width="50%"
          @close="closedialogVisible"
        >
          <el-radio-group v-model="radio">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核拒绝</el-radio>
          </el-radio-group>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closedialogVisible">取 消</el-button>
            <el-button type="primary" @click="saveConfirm">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          v-if="dialogVisible_msSet"
          title=""
          :visible.sync="dialogVisible_msSet"
          width="30%"
          @close="closedialogVisible_msSet"
        >
          <el-form
            inline
            ref="companyForm"
            :model="msSet_formData"
            label-width="100px"
          >
            <el-form-item
              required
              label="面试时间"
              prop="will_interview_time"
              :rules="[
                {
                  required: true,
                  message: '请选择面试时间',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="msSet_formData.will_interview_time"
                type="datetime"
                placeholder="选择面试时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              required
              label="面试地址"
              prop="will_interview_address"
              :rules="[
                {
                  required: true,
                  message: '请输入面试地址',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                v-model="msSet_formData.will_interview_address"
                placeholder="输入面试地址"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closedialogVisible_msSet">取 消</el-button>
            <el-button type="primary" @click="event_add_submilt_confirm"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </PageHeaderLayout>

    <CreateEdit
      ref="RefAddCandidate"
      @confirm="createPositionConfirm"
    ></CreateEdit>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import CreateEdit from "../components/CreateEdit.vue";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    CreateEdit,
  },
  data() {
    return {
      actionMsSetIds_single: "",
      actionMsSetIds: "",
      msSet_formData: {},
      dialogVisible_msSet: false,
      multMsSetFlag: false,
      recruit_schedule_type: 1,
      examinedialogVisible: false,
      radio: 1,
      tabsActive: "",
      sideIndex: "",
      sideList: [],
      sideListCopy: [],
      sideListTotal: "",
      sidetabIndex: "",
      sideJob: "",
      tabIndex: 0,
      tabs: [
        {
          label: "全部简历",
          val: 1,
          num: 0,
          field: "examine_wait",
          select: [
            {
              label: "审核通过",
              val: 1,
            },
            {
              label: "审核淘汰",
              val: 2,
            },
          ],
          selectVal: "",
          selectShow: false,
        },
        {
          label: "面试邀约",
          val: 2,
          num: 0,
          field: "examine_success",
          select: [
            {
              label: "已邀约",
              val: 1,
            },
            {
              label: "未邀约",
              val: 0,
            },
          ],
          selectVal: "",
          selectShow: true,
        },
        {
          label: "面试结果",
          val: 3,
          num: 0,
          field: "interview_num",
          select: [
            {
              label: "通过",
              val: 1,
            },
            {
              label: "未通过",
              val: 2,
            },
          ],
          selectVal: "",
          selectShow: false,
        },
        {
          label: "入职情况",
          val: 4,
          num: 0,
          field: "sign_num",
          select: [
            {
              label: "已入职",
              val: 1,
            },
            {
              label: "未入职",
              val: 0,
            },
          ],
          selectVal: "",
          selectShow: true,
        },
      ],
      tabsArr: [
        {
          label: "全部岗位",
          val: 0,
          id: "",
        },
        {
          label: "未开始",
          val: 0,
          id: "0",
        },
        {
          label: "进行中",
          val: 0,
          id: "1",
        },
        {
          label: "已完成",
          val: 0,
          id: "2",
        },
        {
          label: "已暂停",
          val: 0,
          id: "3",
        },
      ],
      visible: true,
      loadingStaus: false,
      // 搜索条件
      searchCondition: {},
      //任务列表
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      status_text: ["未开始", "进行中", "已完成", "已暂停"],
      work_text: ["", "全职", "兼职", "实习"],
      degree_rext: ["不限", "小学", "初中", "高中", "大专", "本科及以上"],
      columns: [
        {
          title: "姓名",
          value: "realname",
          header_align: "center",
          align: "center",
        },

        {
          title: "手机号",
          value: "mobile",
          header_align: "center",
          align: "center",
        },
        {
          title: "来源",
          value: "source_text",
          header_align: "center",
          align: "center",
        },
        {
          title: "最高学历",
          value: "best_education_text",
          header_align: "center",
          align: "center",
        },
        // {
        //   title: "工作地点",
        //   value: "address_text",
        //   header_align: "center",
        //   align: "center",
        // },
        {
          title: "行业",
          value: "industry_type_text",
          header_align: "center",
          align: "center",
        },
        // {
        //   title: "备注",
        //   value: "remark",
        //   header_align: "center",
        //   align: "center",
        // },
      ],
    };
  },
  computed: {},
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    visible: function(v) {
      console.log("visible", v);
    },
  },
  methods: {
    async event_add_submilt_confirm() {
      // 调用组件的数据验证方法
      this.$refs["companyForm"].validate((valid) => {
        if (valid) {
          let obj = {
            buttonData: {
              flag: "msSet_ensure",
            },
            data: this.msSet_formData,
            flag: "singleSMS",
          };
          this.event_add_submilt(obj);
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    // 按钮组点击
    event_buttonGroupTap(e, row) {
      if (e.item.type && e.item.type == "confirm_second") {
        this.$confirm(`确认${e.item.label}么？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async (arg) => {
            if (arg == "confirm") {
              this.actionId = row.id;
              let obj = {
                buttonData: {
                  flag: e.item.flag,
                },
                data: row,
              };
              this.event_add_submilt(obj);
            }
          })
          .catch(() => {});

        return false;
      }

      this.actionId = row.id;
      let obj = {
        buttonData: {
          flag: e.item.flag,
        },
        data: row,
      };
      this.event_add_submilt(obj);
    },
    closedialogVisible_msSet() {
      this.dialogVisible_msSet = false;
      this.msSet_formData = {};
    },
    // 提交
    async event_add_submilt(e) {
      switch (e.buttonData.flag) {
        case "smsInterview":
          this.multMsSetFlag = false;
          this.actionMsSetIds_single = e.data.id;
          this.dialogVisible_msSet = !this.dialogVisible_msSet;
          this.msSet_formData = {};
          break;
        case "ensureInJob":
          var res_ensureInJob = await this.$api.multSetRecruitStatus({
            ids: [e.data.id],
            type: 3,
            status: 1,
          });
          if (res_ensureInJob.error_num == 0) {
            this.$message.success("操作成功!");
            this.init("search");
          } else {
            if (res_ensureInJob.error_num == 1) {
              this.$message.warning(res_ensureInJob.error_list[0].error_msg);
            } else {
              this.dialogs.errList.show = true;
              this.dialogs.errList.data = res_ensureInJob.error_list;
            }
          }
          break;
        case "ensureLeaveJob":
          var res_ensureLeaveJob = await this.$api.multSetRecruitStatus({
            ids: [e.data.id],
            type: 3,
            status: 2,
          });
          if (res_ensureLeaveJob.error_num == 0) {
            this.$message.success("操作成功!");
          }
          this.init("search");
          break;
        case "showfj":
          if (e.data.resume_url) {
            window.open(e.data.resume_url);
          } else {
            this.$message.warning("暂无附件可查看!");
          }
          break;
        case "msSet_ensure":
          var { will_interview_time, will_interview_address } = e.data;
          var params_msSet = {
            will_interview_time,
            will_interview_address,
          };

          if (this.multMsSetFlag) {
            if (this.actionMsSetIds == "") {
              params_msSet.is_all_interview = 1;
            } else {
              params_msSet.is_all_interview = 2;
              params_msSet.ids = this.actionMsSetIds + "";
            }
          } else {
            params_msSet.is_all_interview = 2;
            params_msSet.ids = this.actionMsSetIds_single + "";
          }

          await this.$api.multUpdateMsSet(params_msSet);
          if (e.flag == "singleSMS") {
            await this.$api.sendMSinvitedMsg({
              ids: params_msSet.ids,
            });
          }

          this.$message.success("操作成功!");

          this.msSet_formData = {};
          this.dialogVisible_msSet = !this.dialogVisible_msSet;

          this.init("search");
          break;
        case "back":
          this.dialogVisible_check = !this.dialogVisible_check;
          break;
        // case "pass":
        //   var params = {
        //     status: 1,
        //     type: 1,
        //   };
        //   await this.this.$post(`recruitTaskCheck('${this.actionId}')`, params);
        //   this.$message.success("操作成功!");

        //   this.init("search");
        //   break;
        // case "nopass":
        //   var params_no = {
        //     status: 2,
        //     type: 1,
        //   };
        //   await this.this.$post(
        //     `recruitTaskCheck('${this.actionId}')`,
        //     params_no
        //   );
        //   this.$message.success("操作成功!");

        //   this.init("search");
        //   break;
        case "interview_pass":
          var params_interview_pass = {
            status: 1,
            type: 2,
          };
          await this.$api.recruitTaskCheck(
            this.actionId,
            params_interview_pass
          );
          this.$message.success("操作成功!");

          this.init("search");
          break;
        case "interview_nopass":
          var params_interview_nopass = {
            status: 2,
            type: 2,
          };
          await this.$api.recruitTaskCheck(
            this.actionId,
            params_interview_nopass
          );
          this.$message.success("操作成功!");

          this.init("search");
          break;
        // 转入面试结果
        case "transferInterviewRess":
          var params_result = {
            data: [
              {
                id: this.actionId,
              },
            ],
          };
          var res_interview_result = await this.$api.joinInterviewResult(
            params_result
          );
          if (res_interview_result.errorNum != 0) {
            this.$message.warning(res_interview_result.errorList[0].error_msgs);
          } else {
            this.$message.success("操作成功!");
            this.init("search");
          }
          break;
        default:
          break;
      }
    },
    // 状态变化
    event_status_change(e, val) {
      let obj = {};
      switch (e) {
        case "examine_wait":
          obj.status = val;
          break;
        case "examine_success":
          obj.is_send_interview = val;
          break;
        case "interview_num":
          obj.interview_status = val;
          break;
        case "sign_num":
          obj.leave_job_status = val;
          break;
        default:
          break;
      }
      this.init("search", obj);
    },
    examineClick(row) {
      this.id = row.id;
      this.radio = 1;
      this.examinedialogVisible = true;
    },
    // 确认保存按钮
    async saveConfirm() {
      this.userInfo();
      return true;
    },
    async userInfo() {
      let obj = {
        status: this.radio,
        type: 1,
      };
      console.log(obj, "obj");

      await this.$api.recruitTaskCheck(this.id, obj);
      this.$nextTick(() => {
        this.$message.success("审核成功!");
        this.init();
        this.closedialogVisible();
      });
    },
    closedialogVisible() {
      this.examinedialogVisible = false;
      this.radio = 1;
    },
    // tab标签页改变
    async event_tabClick(e) {
      this.tabs[this.tabIndex].selectVal = "";
      this.tabIndex = e.val - 1;
      this.recruit_schedule_type = e.val;
      this.init("search");
    },
    async recruitTaskList(e = "") {
      let params = {
        current_page: 1,
        page_size: 99999,
      };

      if (e !== "") {
        params.status = e;
      }
      let res = await this.$api.recruitTaskList(params);
      console.log(res, "侧边连岗位");
      this.sideList = res.data;
      this.sideListCopy = res.data;
      this.sideListTotal = res.pages.total;
    },
    // 选择项目
    event_selectProject(e) {
      this.activeTab = e;
      this.sidetabIndex = e;
      this.searchButton();
    },
    event_change(e) {
      this.sideList = this.sideListCopy.filter((item) => {
        return item.recruit_post.includes(e);
      });
    },
    // 获取各阶段数量
    async getCandidateNum(e = {}) {
      if (this.sidetabIndex) {
        e.task_id = this.sidetabIndex;
      }
      let res_num = await this.$api.getCandidateNum(e);
      this.tabs.map((item) => {
        item.num = res_num[item.field];
      });
    },
    event_tabChange(index) {
      this.tabsActive = index;
      this.init("search");
    },
    createPositionConfirm() {
      this.init("search");
    },
    openDialog() {
      this.$refs.RefAddCandidate.open("", "");
    },
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0;
      }
      if (status == 0) {
        missionStatus = 1;
      }
      let args = {
        status: missionStatus,
        id,
      };
      let res = await this.$api.updateDailyPost(args);
      if (res) {
        this.init();
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 初始化
    async init(type, search_obj = {}) {
      this.loadingStaus = false;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
        this.getCandidateNum();
      }
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      searchCondition = {
        ...searchCondition,
        ...search_obj,
        is_import: 0,
        recruit_schedule_type: this.recruit_schedule_type,
      };
      if (this.sidetabIndex) {
        searchCondition.task_id = this.sidetabIndex;
      }
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.employeeList(searchCondition);
      if (type == "export") {
        return data;
      } else {
        this.dataList = data;
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.realname) {
        condition.realname = this.searchCondition.realname;
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.tabsActive) {
        condition.status = this.tabsActive;
      }
      if (this.searchCondition.time_value) {
        condition = {
          ...condition,
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    // 获取候选人状态
    async getTaskStatusList() {
      let res = await this.$api.getTaskStatusList();
      let statusList = [];
      res.map((item) => {
        let obj = {
          label: `${item.key}(${item.num})`,
          val: item.value,
        };
        statusList.push(obj);
      });
      this.tabsArr = statusList;
    },
    // 跳转详情页面
    toView(row) {
      this.$refs.RefAddCandidate.open("details", row.id);
    },
    // 发布岗位
    addPosition() {
      this.$router.push({ path: "/position/create", params: {} });
    },
  },

  created() {},
  mounted() {
    this.recruitTaskList();
    this.getTaskStatusList();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  height: calc(100vh - 260px);
}
.side {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 250px;
  margin-right: 20px;
  background-color: #f6f7f9;
  .input {
    width: 212px;
    height: 30px;
    border-radius: 20px;
    margin-top: 32px;
  }
  .project_type {
    width: 212px;
    color: #364056;
    font-size: 16px;
    margin: 30px 0px;
  }
  .tipTxtTotal {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0px 24px;
    box-sizing: border-box;
    .tipTxtTotal_left {
      color: #121212;
      font-size: 16px;
    }
    .tipTxtTotal_right {
      font-size: 12px;
      color: var(--default-text-color);
      text-decoration: underline;
      cursor: pointer;
    }
    .tipTxtTotal_left_theme {
      color: #1890ff;
    }
    .scrollbarWrap {
      width: 100%;
      overflow: hidden;
      flex: 1;
    }
  }
  .scrollbarWrap {
    :deep(.el-scrollbar__wrap--hidden-default) {
      scrollbar-width: none;
    }
    flex: 1;
  }
  .scrolllist {
    flex-direction: column;
    flex-direction: row;
    width: 250px;
    height: 100%;
    overflow-y: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column;
    .listcell {
      min-height: 56px;
      width: 100%;
      padding: 12px 26px 12px 28px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      font-size: 16px;
      color: #364056;
      flex: none;
      .listcell_text {
        flex: 1;
        display: flex;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        line-height: 1.5;
        margin-right: 20px;
      }
      .listcell_num {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #364056;
        font-family: PingFang SC;
      }
      &.active {
        cursor: pointer;
        background: #1890ff;
        color: #fff;
        .listcell_num {
          color: #fff;
        }
      }
      &:hover {
        cursor: pointer;
        background: #1890ff;
        color: #fff;
        .listcell_num {
          color: #fff;
        }
      }
    }
  }
}
.mian-content {
  display: flex;
  height: 100%;
  .list {
    flex: 1;
  }
}
.wrap-tab {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item {
      margin-right: 20px;
      background: #d6e2ff;
      height: 35px;
      min-width: 120px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all ease 0.3s;
      .label {
        font-size: 12px;
        font-weight: 600;
        color: #121212;
      }
      .val {
        color: #1890ff;
      }
      &.active {
        background: #1890ff;
        .label {
          font-size: 12px;
          font-weight: 600;
          color: #fff;
        }
        .val {
          color: #fff;
        }
      }

      &.select {
        padding: 0;
        :deep(.el-select) {
          .el-input__wrapper {
            height: 40px !important;
            border-radius: 10px;
          }
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 3;
}
</style>
